import { render, staticRenderFns } from "./detailTable.vue?vue&type=template&id=d67f4918&"
import script from "./detailTable.vue?vue&type=script&lang=js&"
export * from "./detailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports